define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    var TakeOverViewController = ViewController.extend({
        ControllerName: "TakeOverViewController",

        LPViewMap: {
            wrapper: '.lpview_take_over_dialog',
            closeButton: ".lpview_close_take_over_dialog",
            cancelButton: ".lpview_cancel_button",
            takeOverButton: ".lpview_take_over_button"
        },

        LPStateMaps: {
            init: 'init',
            loading: 'loading',
            error: 'error',
            success: 'success'
        },

        initialize: function(constructorData) {
            this.chatId = constructorData.chatId;
            this.chatsRootModelPath = constructorData.chatsRootModelPath;
            this.modelController = constructorData.modelController;
        },
        events: function() {
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({selector: this.LPViewMap.cancelButton, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({selector: this.LPViewMap.takeOverButton, DOMEvent: "click", callback: this.handleTakeOverButtonClicked});
        },
        render: function() {
        }
    });

    TakeOverViewController.prototype.updateChatId = function (chatId) {
        if (this.chatId !== chatId) {
            this.chatId = chatId;
            this.lpHide();
        }
    };

    TakeOverViewController.prototype.showDialog = function () {
        this.lpShow();
    };

    TakeOverViewController.prototype.hideDialog = function () {
        this.lpHide();
        this.resetState();
    };

    TakeOverViewController.prototype.handleTakeOverButtonClicked = function () {
        var assignedAgentId = this.modelController.getModelParam(this.chatsRootModelPath + this.chatId + '.agentInfo.messagingUserId');
        var suggestedAgentId = this.modelController.getModelParam(this.chatsRootModelPath + this.chatId + '.suggestedAgentInfo.messagingUserId');
        
        var request = {
            ownerId: assignedAgentId || suggestedAgentId || '',
            conversationId: this.chatId,
            dialogId: lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId, this.chatsRootModelPath),
            agentId: this.modelController.getModelParam('agent.messagingUserId'),
            success: successCallback.bind(this),
            error: errorCallback.bind(this)
        };
        lpTag.WebAgent.amsController.assignConversationToAgent(request);
        this.setState(this.LPStateMaps.loading);

        function successCallback() {
            this.logger.info('Takeover conversation ended successfully for conversation ' + this.chatId);
            this.hideDialog();
        }

        function errorCallback(error) {
            this.logger.error('Takeover conversation encountered an error for conversation ' + this.chatId);
            this.logger.graph({name: 'takeOverConversationError'});
            this.setState(this.LPStateMaps.error);
        }
    };

    TakeOverViewController.prototype.resetState = function () {
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        var stateClasses = [this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.error, this.LPStateMaps.init];
        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, this.LPStateMaps.init);
    };

    /**
     * set the dialog state.
     * @param state
     */
    TakeOverViewController.prototype.setState = function (state) {
        var stateClasses = [this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.error, this.LPStateMaps.init];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }

        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, state);
    };

    return TakeOverViewController;

});
